import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../shared/page-accordion';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        let openedSections = [];
        this.hexArray = props.report.product.inputs.lines.reverse();

        if (props.report.product.display.sections.length == 1) {
            const openId = `hexagram-${props.report.product.display.sections[0].block[0].content[0].index}`;
            openedSections = [openId];
        }

        if (props.hash) {
            openedSections.push(props.hash);
        }

        this.state = {
            openedSections: openedSections,
            category: props.category,
            code: props.upc,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.hash != this.props.hash) {
            if (nextProps.hash != '') {
                if (nextProps.hash === 'main') {
                    this.setState({ openedSections: []});
                    accScroll('main', 500);
                } else {
                    const opened = toggleSection(this.state.openedSections, nextProps.hash);
                    const state = this.state;
                    state.openedSections = opened;
                    this.setState(state);
                }
            }
            return true;
        }

        if (nextState != this.state) {
            return true;
        }

        return false;
    }

    render() {
        return (<i-ching-interps>{this.renderInterps()}</i-ching-interps>);
    }

    onClickHandler = (id, e) => {
        e.preventDefault();

        const clickResult = onClickAccHandler(this.state.openedSections, id, this.props.hash);
        const clickState = this.state;

        clickState.openedSections = clickResult[0];
        this.setState(clickState);

        if (clickResult[1] == true) {
            this.props.routeTo(id);
        }

        if (clickResult[2] == true) {
            accScroll(id, 400);
        }
    }

    renderLines = (line, slant, loop) => {
        const filename = this.renderSingleLine(line, loop);

        return (
            <column className='is-12'>
                <img
                    src={`https://gfx.tarot.com/images/iching/iching-${slant}/hexagram-lines/${filename}.svg`}
                    alt={filename}
                    className='i-ching-line-thumb'
                />
            </column>
        );
    }

    renderSingleLine = (line, loop) => {
        switch (line) {
            case 6:
                return loop == 1 ? 'solid-line' : 'broken-changing';
            case 7:
                return 'solid-line';
            case 8:
                return 'broken-line';
            case 9:
                return loop == 1 ? 'broken-line' : 'solid-changing';
            default:
                return 'none';
        }
    }

    renderInterps = () => {
        const report = this.props.report;
        if (report.upsell_upc === null) {
            return (
                !report.product.display.sections[1] && (
                    <section className='interp-accordion'>
                        {report.product.display.sections[0].block.map((block) => (this.renderAccNoChange(block)))}
                    </section>
                )
            );
        } else if (!!report.upsell_upc && (report.upsell_upc !== null)) {
            return (<section className='interp-accordion'>{this.renderAccChanging(report)}</section>);
        }

        return (<section className='interp-accordion'>{this.renderAccUpgraded(report)}</section>);
    }

    /* eslint-disable max-len */
    renderAccNoChange = (block) => {
        return (
            <div>
                {(block.content[0].index
                    ? <h2>{block.content[0].index}: {block.content[0].title}</h2>
                    : <h2>{block.content[0].title}</h2>
                )}
                {(block.content[0].body.map(body =>
                    <p>
                        {body}
                        <br />
                        {(!!block.content[0].link && (
                            <a href={block.content[0].link.url.replace('https://www.tarot.com', '')}>
                                CONSULT THE I-CHING AGAIN
                            </a>
                        ))}
                    </p>
                ))}
                {!!block.content[0].link && (
                    <div className='has-text-center'>
                        <a
                            className={`is-hidden-print button i-ching ${this.props.report.product.mechanics.interpretation_set}`}
                            href={block.content[0].link.url.replace('https://www.tarot.com', '')}
                        >
                            CONSULT THE I-CHING AGAIN
                        </a>
                    </div>
                )}
            </div>
        );
    }
    /* eslint-enable max-len */

    renderAccChanging = (report) => {
        const section = report.product.display.sections[0];
        const id = `hexagram-${section.block[0].content[0].index}`;
        const slant = report.product.mechanics.interpretation_set == 'iching-general' ? 'general' : 'love';
        const last = report.product.display.sections[0].block.length - 1;
        const endBlock = report.product.display.sections[0].block[last];
        const isOpen = sectionIsOpen(this.state.openedSections, id);
        /* eslint-disable max-len */
        return (
            <div>
                <div
                    className={`interp-accordion-item ${isOpen ? ' accordion-open' : ' accordion-closed'}`}
                    id={id}
                >
                    <a
                        href={`#hexagram-${section.block[0].content[0].index}`}
                        className='interp-accordion-item-tab'
                        onClick={(e) => this.onClickHandler(id, e)}
                    >
                        <row className='is-aligned-center has-padding-10-top has-padding-10-bottom'>
                            <column className='is-1 is-2-mobile has-text-left-print has-text-center'>
                                <row className='is-wrap has-margin-10-left-desktop has-margin-10-left-tablet'>
                                    {this.hexArray.map(line => (this.renderLines(line, slant)))}
                                </row>
                            </column>
                            <column className='is-11 is-10-mobile'>
                                <div className='has-margin-20-left has-weight-300 has-text-size-18 has-text-color-black'>
                                    {section.title}
                                </div>
                                <div className='has-margin-20-left has-margin-0-top has-text-size-14 has-text-boulder'>
                                    {section.block[0].content[0].index}: {section.block[0].content[0].title}
                                </div>
                            </column>
                        </row>
                    </a>
                    <div className='interp-accordion-item-content' id={`hexagram-${section.block[0].content[0].index}`}>
                        {
                            section.block.map((block, forloop) => (
                                block.content[0].body.map((body, loop) => (
                                    <div>
                                        {(forloop == section.block.length - 1 && loop === 0) && (
                                            <h2 className='has-margin-10-bottom'>The Future of This Situation:</h2>
                                        )}
                                        <p>
                                            {body}
                                            {(!!loop.last && !!block.content[0].link) && (
                                                <a href={block.content[0].link.url}>{block.content[0].link.text}</a>
                                            )}
                                        </p>
                                    </div>
                                ))
                            ))
                        }
                    </div>
                </div>
                {!!endBlock.content[0].link && (
                    <div className='has-text-center'>
                        <a
                            className={`is-hidden-print button i-ching ${report.product.mechanics.interpretation_set}`}
                            href={endBlock.content[0].link.url.replace('https://www.tarot.com', '')}
                        >
                            GET FULL READING
                        </a>
                    </div>
                )}
            </div>
        );
        /* eslint-disable max-len */
    }

    renderAccUpgraded = (report) => {
        /* eslint-disable max-len,tarot/href-no-trailing-slash */
        return (
            <div>
                {report.product.display.sections.map((section, loop) => (this.renderAccUpgradedItem(section, loop)))}
                <div className='has-text-center'>
                    <br />
                    <a
                        className={`is-hidden-print button i-ching ${report.product.mechanics.interpretation_set}`}
                        href={report.product_url.replace('https://www.tarot.com', '')}
                    >
                        CONSULT THE I-CHING AGAIN
                    </a>
                    <br />
                    <br />
                    <a href='http://divination.com/freebook/' target='_blank' rel='noreferrer'>
                        <img src='https://gfx.tarot.com/images/iching/iching-general/desktop-ad.jpg' alt='Desktop I-Ching' className='is-hidden-print is-hidden-mobile' />
                        <img src='https://gfx.tarot.com/images/iching/iching-general/mobile-ad.jpg' alt='Mobile I-Ching' className='is-hidden-print is-visible-mobile' />
                    </a>
                </div>
            </div>
        );
        /* eslint-enable max-len,tarot/href-no-trailing-slash */
    }

    renderAccUpgradedItem = (section, loop) => {
        const id = `hexagram-${section.block[0].content[0].index}`;
        const isOpen = sectionIsOpen(this.state.openedSections, id);
        const slant = (this.props.report.product.mechanics.interpretation_set == 'iching-general') ? 'general' : 'love';
        /* eslint-disable max-len */
        return (
            <div>
                <div
                    className={`interp-accordion-item ${isOpen ? ' accordion-open' : ' accordion-closed'}`}
                    id={id}
                >
                    <a
                        href={`#hexagram-${section.block[0].content[0].index}`}
                        className='interp-accordion-item-tab'
                        onClick={(e) => this.onClickHandler(id, e)}
                    >
                        <row className='is-aligned-center has-padding-10-top has-padding-10-bottom'>
                            <column className='is-1 is-2-mobile has-text-left-print has-text-center'>
                                <row className='is-wrap has-margin-10-left-desktop has-margin-10-left-tablet'>
                                    {this.hexArray.map(line => (this.renderLines(line, slant, loop)))}
                                </row>
                            </column>
                            <column className='is-11 is-10-mobile'>
                                <div className='has-margin-20-left has-weight-300 has-text-size-18 has-text-color-black'>
                                    {section.title}
                                </div>
                                <div className='has-margin-20-left has-margin-0-top has-text-size-14 has-text-boulder'>
                                    {section.block[0].content[0].index}: {section.block[0].content[0].title}
                                </div>
                            </column>
                        </row>
                    </a>
                    <div className='interp-accordion-item-content' id={`#hexagram-${section.block[0].content[0].index}`}>
                        {section.block.map(block => (
                            <div>
                                {(block.type == 'Content' && !!block.content[0].title) && (<h2>{block.content[0].title}</h2>)}
                                {block.content.map(content => (
                                    <div>
                                        {!!content.changing_line && (<h2>{content.title}</h2>)}
                                        {content.body.map(body => (
                                            <p>
                                                {body}
                                                {!!block.content[0].link && (
                                                    <a href={block.content[0].link.url}>{block.content[0].link.text}</a>
                                                )}
                                            </p>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        ))}
                        <p className='is-hidden-print has-text-right'>
                            <a
                                href='#'
                                onClick={(e) => this.onClickHandler('main', e)}
                            >
                                Back to Top
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        );
        /* eslint-enable max-len */
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    hash: state.route,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
